"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiGrid from "@/components/grid/UiGrid.vue";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import _ from "lodash";
let HandleMumbersExcelDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.importTitle = this.$t("handle_mumber_excel_dialog.title");
    this.activestep = 0;
    this.errorMessage = null;
    this.errorTimeout = null;
    this.errorNum = 0;
    this.session_id = null;
    this.downloadmodel = _.debounce(() => __async(this, null, function* () {
      this.downloadrenewtable();
    }), 800);
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  closeDialog() {
    this.dialog.visible = false;
    this.activestep = 0;
    this.errorMessage = null;
    this.errorTimeout = null;
    this.errorNum = 0;
    this.session_id = null;
    this.$emit("refresh");
  }
  open() {
    return __async(this, null, function* () {
      this.dialog.visible = true;
    });
  }
  downloadrenewtable() {
    return __async(this, null, function* () {
      try {
        this.$message.success(this.$t("multiimportmembers.getting_the_download_link_starting_the_download_later"));
        let downloadWin = window.open("", "_self");
        downloadWin.location.href = "https://downloadcdn.yunmai365.com/export_account_excel/handleUsersTemplate.xlsx";
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  elInFile(file) {
    return __async(this, null, function* () {
      try {
        this.errorMessage = null;
        clearTimeout(this.errorTimeout);
        if (file.name.indexOf(".xlsx") === -1) {
          this.errorMessage = this.$t("multiimportmembers.upload_file_format_must_be");
          this.errorTimeout = setTimeout(() => {
            this.errorMessage = null;
          }, 5e3);
          return;
        }
        this.activestep = 1;
        const formdata = new window.FormData();
        formdata.append("file", file.raw);
        yield API.post(`api://base.auth/api/v1/users/operate-from-excel`, formdata);
        this.activestep = 2;
        return;
      } catch (error) {
        this.activestep = 0;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
HandleMumbersExcelDialog = __decorateClass([
  Component({
    components: {
      UiGrid,
      UiDialog
    }
  })
], HandleMumbersExcelDialog);
export {
  HandleMumbersExcelDialog as default
};
